export default __webpack_public_path__ + "static/media/settings.5fb20ebf.svg";